// extracted by mini-css-extract-plugin
export default {"container":"CollectingStatistics_container__6uVZ0","tableWrapper":"CollectingStatistics_tableWrapper__vOj9y","table":"CollectingStatistics_table__DoEYc"};